export default __webpack_public_path__ + "static/media/marketing_img_1.fc7814d3.jpg";